exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 0px) {\n}\n@media screen and (max-width: 981px) {\n.container[data-v-05c02aa6] {  \n      font-size: 4em;\n}\n.glyphicon-tamano[data-v-05c02aa6] {\n      font-size: 3em !important;\n}\ninput[data-v-05c02aa6] {        \n      position:relative;\n      width:100%;\n      height:100px;\n      font-size: 0.8em;\n}\nbutton[data-v-05c02aa6] {        \n      position:relative;\n      width:100%;\n      height:100px;\n      font-size: 0.8em;\n}\n}\n@media screen and (min-width: 981px) {\n.container[data-v-05c02aa6] {        \n      font-size: 1.4em;    \n      width: 400px;\n}\nbutton[data-v-05c02aa6] {               \n      font-size: 1.2em;\n}\ninput[data-v-05c02aa6] {               \n      font-size: 1em;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-05c02aa6","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/membership/Register.vue
// module id = 70
// module chunks = 0